import React, { useEffect, useState } from 'react';
import { Achievement } from '../types';
import './AchievementNotification.css';

interface AchievementNotificationProps {
  achievement: Achievement;
  onClose: () => void;
  autoClose?: boolean;
  duration?: number;
}

const AchievementNotification: React.FC<AchievementNotificationProps> = ({
  achievement,
  onClose,
  autoClose = true,
  duration = 5000
}) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Animación de entrada
    const showTimer = setTimeout(() => {
      setIsVisible(true);
    }, 100);

    // Auto-close
    let closeTimer: NodeJS.Timeout;
    if (autoClose) {
      closeTimer = setTimeout(() => {
        handleClose();
      }, duration);
    }

    return () => {
      clearTimeout(showTimer);
      if (closeTimer) clearTimeout(closeTimer);
    };
  }, [autoClose, duration]);

  const handleClose = () => {
    setIsVisible(false);
    setTimeout(onClose, 300); // Esperar a que termine la animación
  };

  const getRarityColor = (rarity: string) => {
    switch (rarity) {
      case 'common': return '#10b981';
      case 'rare': return '#3b82f6';
      case 'epic': return '#8b5cf6';
      case 'legendary': return '#f59e0b';
      default: return '#6b7280';
    }
  };

  const getRarityText = (rarity: string) => {
    switch (rarity) {
      case 'common': return 'Común';
      case 'rare': return 'Raro';
      case 'epic': return 'Épico';
      case 'legendary': return 'Legendario';
      default: return 'Común';
    }
  };

  return (
    <div 
      className={`achievement-notification ${isVisible ? 'visible' : ''}`}
      style={{ '--rarity-color': getRarityColor(achievement.rarity) } as React.CSSProperties}
    >
      <div className="notification-content">
        <div className="notification-header">
          <div className="celebration">🎉</div>
          <h3>¡Logro Desbloqueado!</h3>
          <button className="notification-close" onClick={handleClose}>
            ✕
          </button>
        </div>
        
        <div className="achievement-info">
          <div className="achievement-icon-large">
            {achievement.icon}
          </div>
          
          <div className="achievement-details">
            <h4 className="achievement-title">{achievement.name}</h4>
            <p className="achievement-desc">{achievement.description}</p>
            
            <div className="achievement-meta-info">
              <span 
                className="rarity-badge" 
                style={{ backgroundColor: getRarityColor(achievement.rarity) }}
              >
                {getRarityText(achievement.rarity)}
              </span>
              <span className="points-badge">
                +{achievement.points} puntos
              </span>
            </div>
          </div>
        </div>
      </div>
      
      <div className="notification-progress">
        <div 
          className="progress-bar"
          style={{ 
            animationDuration: `${duration}ms`,
            backgroundColor: getRarityColor(achievement.rarity)
          }}
        />
      </div>
    </div>
  );
};

export default AchievementNotification;